import { useTheme as useCTheme, WithCSSVar } from '@chakra-ui/react';
import { Theme } from '../../theme/theme.types';

export const useTheme = (): WithCSSVar<Theme> => useCTheme<Theme>();
